import { useTranslations } from '@vocab/react';
import { Button } from 'braid-design-system';

import translations from './.vocab';

export const PreviewButton = ({
  onMouseOver,
  onClicked,
}: {
  onMouseOver: () => void;
  onClicked: () => void;
}) => {
  const { t } = useTranslations(translations);
  return (
    <div onMouseOver={onMouseOver}>
      <Button type="button" variant="ghost" onClick={onClicked}>
        {t('preview-button-text')}
      </Button>
    </div>
  );
};
